__turbopack_context__.v({
  "attributes": "styles-module__GjrnEq__attributes",
  "card": "styles-module__GjrnEq__card",
  "image": "styles-module__GjrnEq__image",
  "isPortrait": "styles-module__GjrnEq__isPortrait",
});
